export const validationMessage = {
  required: "This field is required"
} as const;
